import React, { useState } from "react";
import Menu from "./component/menu/Menu";
import "./App.css";
import { createTheme, ThemeProvider } from "@material-ui/core/styles";
import { Route, Routes } from "react-router";
import {  HashRouter } from "react-router-dom";
import rutas from "./route-config";
import PieContext from "./PieContext";
import Footer from "./utils/controlls/Footer";

const theme = createTheme({
  palette: {
    primary: {
      main: "#24135f",
      dark: "#000051",
      contrastText: "#fff",
      light: "#534bae",
    },
    secondary: {
      light: '#24135f',
      main: '#24135f',
      dark: '#004c8c',
      contrastText: '#ffffff',
    },
  },
});

function App() {
  const [dataEstadistica, setDataEstadistica] = useState<any[]>([]);
  const [dataEstadisticaFiltered, setDataEstadisticaFiltered] = useState<any[]>([]);
  const [dataEstadisticaPaged, setDataEstadisticaPaged] = useState<any[]>([]);
  const [añosSelect, setAñosSelect] = useState<number[]>([1996, 2022]);
  const [filtrosSelect, setFiltrosSelect] = useState<any>({});
  const [dataEstatica, setDataEstatica] = useState<any>({});
  
  function actualizaDataEstadistica(dataE: any[]){
    setDataEstadistica(dataE);
  }
  function actualizaDataEstadisticaFiltered(dataE: any[]){
    setDataEstadisticaFiltered(dataE);
  }
  function actualizaDataEstadisticaPaged(dataE: any[]){
    setDataEstadisticaPaged(dataE);
  }
  function actualizaAñosSelect(años: number[]) {
    setAñosSelect(años);
  }
  function actualizaFiltros(filtro: any){
    setFiltrosSelect(filtro);
  }
  function actualizaDataEstatica(data: any[]) {
    setDataEstatica(data);
  }

  return (
    <ThemeProvider theme={theme}>
      <HashRouter 
      // basename="/pie_dev"
      >
      <PieContext.Provider
        value={
          {
            dataEstadistica, 
            actualizaDataEstadistica, 
            dataEstadisticaFiltered, 
            actualizaDataEstadisticaFiltered, 
            dataEstadisticaPaged, 
            actualizaDataEstadisticaPaged, 
            añosSelect, 
            actualizaAñosSelect,
            filtrosSelect,
            actualizaFiltros,
            dataEstatica,
            actualizaDataEstatica,
          }
        }>
        <Menu />
          <Routes>
            {rutas.map((ruta) => (
              <Route
                key={ruta.path}
                path={ruta.path}
                element={<ruta.componente />}
              />
            ))}
          </Routes>
        </PieContext.Provider>
      </HashRouter>
      <Footer />
    </ThemeProvider>
  );
}

export default App;
